module.exports = __webpack_public_path__ + "static/media/998044.1619a7e4.jpg";